import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";
import { MobileFaq } from "./mobile/mobile-faq";
import { AuroraOrb } from "@/components/vision/aurora-orb";
import { Reveal, RevealStagger } from "@/components/vision/reveal";
import { EditorialHeading } from "./editorial-heading";

export function FaqSection() {
  const { t } = useTranslation();
  const faqs = t("faq.items", { returnObjects: true }) as { q: string; a: string }[];
  return (
    <>
    <div className="md:hidden"><MobileFaq /></div>
    <section id="faq" className="relative overflow-hidden py-28 hidden md:block">
      <AuroraOrb color="violet" size={520} className="-left-32 top-10" delay={0} />
      <AuroraOrb color="cyan" size={440} className="right-[-6rem] bottom-10" delay={4} />
      <div className="relative mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <EditorialHeading
          index="No. 10"
          eyebrow={t("faq.eyebrow")}
          title={t("faq.title")}
        />
        <RevealStagger className="mt-12 space-y-3" stagger={0.06} y={20} blur={6}>
          {faqs.map((f, i) => (
            <Accordion key={i} type="single" collapsible>
              <AccordionItem value={`item-${i}`} className="vision-card rounded-2xl border-0 px-5">
                <AccordionTrigger className="text-left text-base font-medium hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted-foreground">{f.a}</AccordionContent>
              </AccordionItem>
            </Accordion>
          ))}
        </RevealStagger>
      </div>
    </section>
    </>
  );
}
